import React from "react";
import { Line } from "react-konva";

export function DistanceGuideline({
  coord,
  segment,
  direction,
  scale = 1,
  margin = 5,
  offset = 0,
  adornmentSize = 5,
}: {
  coord: number;
  segment: [number, number];
  direction: "horizontal" | "vertical";
  scale?: number;
  margin?: number;
  offset?: number;
  adornmentSize?: number;
}) {
  let line, startLine, endLine;
  const lineCoord = coord + offset;
  const start = Math.min(...segment) + margin;
  const end = Math.max(...segment) - margin;

  if (direction === "horizontal") {
    line = [start, lineCoord, end, lineCoord];
    startLine = [start, lineCoord - adornmentSize, start, lineCoord + adornmentSize];
    endLine = [end, lineCoord - adornmentSize, end, lineCoord + adornmentSize];
  } else {
    line = [lineCoord, start, lineCoord, end];
    startLine = [lineCoord - adornmentSize, start, lineCoord + adornmentSize, start];
    endLine = [lineCoord - adornmentSize, end, lineCoord + adornmentSize, end];
  }

  return (
    <>
      <Line points={line} strokeWidth={1 / scale} stroke="#00A1FF" />
      <Line points={startLine} strokeWidth={1 / scale} stroke="#00A1FF" />
      <Line points={endLine} strokeWidth={1 / scale} stroke="#00A1FF" />
    </>
  );
}
